"use strict";

exports.__esModule = true;
exports.default = void 0;
var LOOP_STATUS = {
  OVER: 'over',
  UNDER: 'under',
  ASIS: 'as-is'
};
var _default = LOOP_STATUS;
exports.default = _default;